<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['users.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'USERS.USERS_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], [])"
        type="button"
        class="btn btn-secondary"
        (click)="export()"
      >
        {{ 'USERS.USERS_LIST.EXPORT' | translate }}
      </button>

      <button
        *ngIf="
          accessService.hasAccess(
            [UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER, UserRoleType.IT],
            ['users.store']
          )
        "
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'USERS.USERS_LIST.ADD_USER' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="usersResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Users', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'USERS.USERS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="fake_names"
      title="{{ 'USERS.USERS_LIST.FAKE_NAMES' | translate }}"
      filter="text"
      [sortable]="false"
      [hidden]="isHiddenColumn('fake_names')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-user-box [user]="dataItem"></app-user-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="real_names"
      title="{{ 'USERS.USERS_LIST.REAL_NAMES' | translate }}"
      filter="text"
      [sortable]="false"
      [hidden]="isHiddenColumn('real_names')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.first_name }} {{ dataItem.middle_name }} {{ dataItem.last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="email"
      title="{{ 'USERS.USERS_LIST.EMAIL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('email')"
    >
    </kendo-grid-column>

    <kendo-grid-column title="{{ 'USERS.USERS_LIST.ROLES' | translate }}" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.getRolesNames() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="extension"
      title="{{ 'USERS.USERS_LIST.EXTENSION' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('extension')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let contact of dataItem?.contacts; let i = index">
          <div *ngIf="contact?.type_id == ContactTypes.EXTENSION">
            {{ contact?.value }}<span *ngIf="contact?.note">({{ contact?.note }})</span>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="employee"
      title="{{ 'USERS.USERS_LIST.EMPLOYEE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('employee')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.employee"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'USERS.USERS_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="enable_notifications"
      title="{{ 'USERS.USERS_LIST.NOTIFICATIONS' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('enable_notifications')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.enable_notifications"></app-active-indicator>
        <div>
          unread: <strong>{{ dataItem.unread_notifications_count }}</strong>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'USERS.USERS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button [link]="['/settings/users/view']" [params]="{ id: dataItem.id }"> </app-preview-button>

        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER, UserRoleType.IT],
              ['users.show']
            )
          "
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([], ['users.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <!--        <app-activities [subjectId]="dataItem.id" [subjectType]="LaravelModels.USER"></app-activities>-->

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], ['media.index'])"
          [ngbTooltip]="'USERS.USERS_LIST.UPLOAD_DOCUMENTS' | translate"
          container="body"
          [icon]="'fal fa-file'"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.USER"
          [acceptType]="MediaLibraryAcceptTypes.ALL"
        ></app-media-library-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
